export enum ROUTE_WEBAPP {
  BASE = 'webapp',
  ADD = 'add',
  PROJECTS = 'projects',
  REPORTING = 'reporting',
}
